import { render, staticRenderFns } from "./RemitCustomsReport.vue?vue&type=template&id=103bb3dc&scoped=true&"
import script from "./RemitCustomsReport.vue?vue&type=script&lang=js&"
export * from "./RemitCustomsReport.vue?vue&type=script&lang=js&"
import style0 from "./RemitCustomsReport.vue?vue&type=style&index=0&id=103bb3dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103bb3dc",
  null
  
)

export default component.exports